import { Switch, Route } from 'react-router-dom';

import authenticated from 'containers/Authenticated';

import CompanyDetails from 'views/PlatformSettings/CompanyDetails';
import Users from 'views/PlatformSettings/Users';
import JobTitles from 'views/PlatformSettings/JobTitles';
import Departments from 'views/PlatformSettings/Departments';

/* eslint-disable react/jsx-max-props-per-line */
function PlatformSettingsRoutes() {
  return (
    <Switch>
      <Route path={`/settings/company-details`} component={authenticated(CompanyDetails)} exact />
      <Route path={`/settings/users`} component={authenticated(Users)} exact />
      <Route path={`/settings/job-titles`} component={authenticated(JobTitles)} exact />
      <Route path={`/settings/departments`} component={authenticated(Departments)} exact />
    </Switch>
  );
}
/* eslint-enable react/jsx-max-props-per-line */

export default PlatformSettingsRoutes;
